import React, { useState } from 'react';
import { ILineChartSubmissionData, LineChart } from './LineChart';
import { View, Text, StyleSheet } from 'react-native';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import { Stack } from '@mui/material';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { IAdvancedContest } from '../../types/global/helper';
import { PopOverMore } from '../More/PopoverMoreMenu';
import { filter_more } from '../More/more.data';

export interface IChart extends ILineChartSubmissionData {
    contest: IAdvancedContest;
    trendSelector?: 'vote' | 'submission';
    handleFilterSelect: (filter: string) => void;
}

const Chart: React.FC<IChart> = ({ contest, trendSelector, handleFilterSelect }: IChart) => {
    const { vote_trend, submission_trend, vote_stats, submission_stats } = contest;
    const { themeStyle } = useThemeContext();
    const [filter, setFilter] = useState('Month');
    const styles = dynamicStyle(themeStyle);
    const trend = trendSelector === 'submission' ? submission_trend : vote_trend;
    const handleMoreItemClick = (moreType: string) => {
        setFilter(moreType);
        if (moreType.toLowerCase() === 'month') {
            handleFilterSelect(moreType);
        }

        if (moreType.toLowerCase() === 'week') {
            handleFilterSelect(moreType);
        }
    };
    return (
        <View
            style={{
                backgroundColor: theme[themeStyle].gray_text,
                borderRadius: 10,
                padding: 10,
                width: '100%',
                height: 'auto',
                maxHeight: '362px',
            }}>
            <Stack flexDirection="row" justifyContent="space-between" alignItems="center" padding={2}>
                <Stack>
                    <Text style={styles.vote}>{trendSelector === 'vote' ? 'Vote Trend' : 'Submission Trend'}</Text>
                    <Text style={styles.percentage}>{trend[0]}%</Text>
                </Stack>
                <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
                    <Text style={styles.filter}>Filter by</Text>
                    <Text style={styles.param}> {filter}</Text>
                    <PopOverMore
                        onClick={handleMoreItemClick}
                        menu={filter_more}
                        typographyStyle={{
                            fontFamily: FONT_ENUM.MAIN_REGULAR,
                            fontSize: 14,
                            color: theme[themeStyle].tag_white,
                        }}
                    />
                </Stack>
            </Stack>
            <LineChart submissionStat={submission_stats} trendSelector={trendSelector} voteStat={vote_stats} />
        </View>
    );
};

Chart.defaultProps = {
    trendSelector: 'vote',
};

export { Chart };

const dynamicStyle = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        vote: {
            color: theme[colorScheme].lightWhite,
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            fontWeight: '500',
            fontSize: 16,
        },
        percentage: {
            color: theme[colorScheme].lightWhite,
            fontFamily: FONT_ENUM.MAIN_BOLD,
            fontWeight: '600',
            fontSize: 30,
        },
        filter: {
            color: theme[colorScheme].lightWhite,
            fontFamily: FONT_ENUM.MAIN_REGULAR,
            fontWeight: '500',
            fontSize: 14,
        },
        param: {
            color: theme[colorScheme].highlight,
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            fontWeight: '500',
            fontSize: 14,
        },
    });
